import React from 'react'
import { Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

const Logo = ({ disabledLink = false, sx }) => {
  return (
    <Typography
      variant="h6"
      component={disabledLink ? 'div' : RouterLink}
      to={disabledLink ? undefined : '/'}
      sx={{
        color: 'inherit',
        textDecoration: 'none',
        fontWeight: 'bold',
        ...sx,
      }}
    >
      KotoZapis
    </Typography>
  )
}

export default Logo
